import { styled } from '@mui/system'
import { Stack } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

const TasksHeaderStack = styled(Stack)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'flex-start',
	marginBottom: '1.6rem',
	'.MuiButton-text': {
		fontSize: '1.125rem',
		padding: 0,
		marginLeft: '0.5rem',
		textDecoration: 'underline',
		marginTop: '0.5rem',
		'&:hover': {
			backgroundColor: 'initial',
		},
	},
	'.MuiTypography-subtitle2': {
		marginRight: '0.275rem',
		paddingTop: '0.5rem',
	},
	'.MuiTypography-h3': {
		[theme.breakpoints.down('lg')]: {
			fontSize: '2.375rem',
		},
	},
}))

const TasksHeaderRightActionsBox = styled(Box)`
	display: flex;
	'@media(max-width: 1402px)': {
		flex-direction: column-reverse;
		align-items: flex-end;
	}
`

const TasksHeaderRightActionsBtnsBox = styled(Box)`
	display: flex;
	'@media(max-width: 1402px)': {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
	}
`

const TasksHeaderDeleteTaskButton = styled(Button)`
	font-size: 1rem;
	margin-left: 1.125rem;
	width: 12.5rem;
	height: 2.75rem;
	'@media(max-width: 1402px)': {
		margin-bottom: 1.5rem;
	}
`

const TasksHeaderAddTaskButtonBox = styled(Box)`
	margin-left: 1.125rem;
	'@media(max-width: 1402px)': {
		margin-bottom: 1.5rem;
	}
`

export {
	TasksHeaderStack,
	TasksHeaderRightActionsBox,
	TasksHeaderRightActionsBtnsBox,
	TasksHeaderDeleteTaskButton,
	TasksHeaderAddTaskButtonBox,
}
